import transactionService from '@/services/transactionService';
import analyticsService from '@/services/analyticsService';

export default {
  namespaced: true,
  state: {
    transactions: [],
    holdings: [], // List of HoldingSummary
    globalCount: 0,
  },

  mutations: {
    setTransactions(state, transactions) {
      state.transactions = Array.isArray(transactions) ? transactions : [];
    },

    setHoldings(state, holdings) {
      state.holdings = holdings;
    },

    setGlobalCount(state, count) {
      state.globalCount = count;
    },

    addTransaction(state, transaction) {
      if (!Array.isArray(state.transactions)) {
        state.transactions = [];
      }
      state.transactions.push(transaction);
      state.globalCount++;
    },

    removeTransaction(state, transactionId) {
      state.transactions = state.transactions.filter(t => t.id !== transactionId);
      state.globalCount = Math.max(0, state.globalCount - 1);
    },

    updateTransaction(state, updatedTransaction) {
      const index = state.transactions.findIndex(t => t.id === updatedTransaction.id);
      if (index !== -1) {
        state.transactions.splice(index, 1, updatedTransaction);
      }
    },
  },

  actions: {
    async fetchTransactions({ commit, dispatch }, portfolioId) {
      try {
        const response = await transactionService.getTransactionsByPortfolio(portfolioId);

        // Extract the transactions array from the response
        const transactions = response.data[portfolioId] || [];
        
        // Extract unique symbol IDs from transactions
        const symbolIds = [...new Set(transactions.map(t => t.symbolId))];

        // Fetch symbols data in batch if there are any transactions
        if (symbolIds.length > 0) {
          await dispatch('symbols/fetchSymbolsByIds', symbolIds, { root: true });
        }
        
        commit('setTransactions', transactions);

      } catch (error) {
        console.error('Error fetching transactions:', error);
        commit('setTransactions', []); // Ensure transactions is an empty array on error
      }
    },

    async fetchPortfolioAnalytics({ commit }, portfolioId) {
      try {
        const response = await analyticsService.getPortfolioAnalytics(portfolioId);
        commit('setHoldings', response.data);
      } catch (error) {
        console.error('Error fetching portfolio analytics:', error);
        commit('setHoldings', []);
      }
    },

    async fetchGlobalCount({ commit, rootState }) {
      try {
        const userEmail = rootState.auth.user?.email;
        if (!userEmail) return;
        const response = await transactionService.getTransactionCount(userEmail);
        commit('setGlobalCount', response.data);
      } catch (error) {
        console.error('Error fetching global transaction count:', error);
      }
    },

    async createTransaction({ commit }, transaction) {
      try {
        const response = await transactionService.createTransaction(transaction);
        commit('addTransaction', response.data);
        return response.data;

      } catch (error) {
        console.error('Error creating transaction:', error);
        throw error;
      }
    },

    async deleteTransaction({ commit }, transactionId) {
      try {
        await transactionService.deleteTransaction(transactionId);
        commit('removeTransaction', transactionId);
      } catch (error) {
        console.error('Error deleting transaction:', error);
      }
    },

    async updateTransaction({ commit }, { transactionId, transaction }) {
      try {
        const response = await transactionService.updateTransaction(transactionId, transaction);
        commit('updateTransaction', response.data);
        return response.data;
      } catch (error) {
        console.error('Error updating transaction:', error);
        throw error;
      }
    },
  },
};
